import firebase from "firebase/app";
import "firebase/messaging";

import {getFirebaseConfig} from "../api/core";

const onMessageCallbacks = [];
let app, config;


const setup = async (targa) => {
    config = await getFirebaseConfig(targa);
    app = firebase.initializeApp(config);
}

const setupMessaging = async (vapidKey, user) => {
    const reg = await registerServiceWorker();
    if (reg) {
        // Retrieve Firebase Messaging object.
        const messaging = firebase.messaging();

        //if the user is logged in
        if (user) {
            // Get Instance ID token. Initially this makes a network call, once retrieved
            // subsequent calls to getToken will return from cache.
            const currentToken = await messaging.getToken({vapidKey: vapidKey, serviceWorkerRegistration: reg});

            if (currentToken) {
                // Handle incoming messages. Called when:
                // - a message is received while the app has focus
                // - the user clicks on an app notification created by a service worker
                //   `messaging.setBackgroundMessageHandler` handler.
                messaging.onMessage((payload) => {
                    onMessageCallbacks.forEach(callback => {
                        callback && callback(payload);
                    })
                });

                return currentToken;
            }
        }
    }

    return false;
}

const registerServiceWorker = async () => {
    // checks service worker support
    if ('serviceWorker' in navigator) {
        return await navigator.serviceWorker.register('/js/be/firebase-messaging-sw.js?' + new URLSearchParams(config).toString());
    }

    return null;
};

const destroy = async () => {
    await app.delete();

    removeOnMessageCallbaks();
    app = null;
    config = null;
}

const addOnMessageCallback = (callback) => {
    onMessageCallbacks.push(callback);
}

const removeOnMessageCallbaks = () => {
    onMessageCallbacks.splice(0, onMessageCallbacks.length);
};

export default {
    setup,
    setupMessaging,
    destroy,
    addOnMessageCallback
}
